<template>
  <div class="underline">
    <!-- <img :src="Head" :style="sideStyle" class="front" /> -->
    <img class="body" :src="bodySrc" :style="bodyStyle" />
    <!-- <img :src="Tail" :style="sideStyle" /> -->
  </div>
</template>

<script>
import Body1 from '@/assets/images/all@2x.png'
import Body2 from '@/assets/images/on_progress_deco_mint_line_all@2x.png'
import Body3 from '@/assets/images/reservation_deco_mint_line_all@2x.png'
// import Tail from '@/assets/images/mintline-end.svg'

export default {
  name: 'VUnderline',
  props: {
    width: {
      type: Number,
      default: 70
    },
    height: {
      type: Number,
      default: 8
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    bodyStyle() {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`
      }
    },
    sideStyle() {
      return {
        height: `${this.height}px`
      }
    },
    bodySrc() {
      return this.bodyArr[this.type]
    }
  },
  data() {
    return {
      bodyArr: [Body1, Body2, Body3]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.underline {
  display: flex;
  justify-content: center;
  align-items: center;

  // .body {
  //   width: 70px;
  //   height: 8px;
  // }
}
</style>